module.exports = __webpack_public_path__ + "img/john-pro.1c055933.jpg";